import React, { useEffect, useRef, useState } from 'react';
import { AiOutlineDelete } from "react-icons/ai";
import { CiEdit } from "react-icons/ci";
import Accordion from 'react-bootstrap/Accordion';
import { useForm } from "react-hook-form";
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import Loader from '../../Components/Loader';
import HttpHelper from '../../service/httpService';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission } from "../../service/userService";
import DashboardWrapper from './DashboardWrapper';
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";


const SecurityObjectName = 'Website.Banner';


const DashboardBanner = (props) => {
    const {
        Bold,
        Italic,
        Underline,
        Strikethrough,
        Subscript,
        Superscript,
        AlignLeft,
        AlignCenter,
        AlignRight,
        AlignJustify,
        Indent,
        Outdent,
        OrderedList,
        UnorderedList,
        Undo,
        Redo,
        FontSize,FontName,
        FormatBlock,
        Link,
        Unlink,
        ViewHtml,
        InsertTable,
        AddRowBefore,
        AddRowAfter,
        AddColumnBefore,
        AddColumnAfter,
        DeleteRow,
        DeleteColumn,
        DeleteTable,
        MergeCells,
        SplitCell,
    } = EditorTools;

    const editor = useRef();
    const [subHeadingData, setSubHeadingData] = useState("");
    const getHtml = () => {
        const view = editor.current.view;
        setValue("SubHeading", EditorUtils.getHtml(view.state))
    };

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [banners, setBanners] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [bannerId, setBannerId] = useState('');
    const [imageCurrentShow, setImageCurrentShow] = useState('');
    const [showImgPopup, setShowImgPopup] = useState(false);
    const [bannerImage, setBannerImage] = useState(null);
    const [originalBannerImage, setOriginalBannerImage] = useState(null);
    const [showLoader, setShowLoader] = useState(false);
    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');

    const [bannerIdUpdate, setBannerIdUpdate] = useState('');
    const [rowVersion, setRowVersion] = useState('');
    const [fileId, setFileId] = useState('');
    const [primaryKeyEncrypted, setPrimaryKeyEncrypted] = useState('');

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing === true) {
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                await HttpHelper.post("Banner/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        BannerUpdate(data, bannerIdUpdate, data.FileId)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                BannerUpdate(data, bannerIdUpdate)
            }
            data.MetaData = JSON.stringify(data.MetaData);
        } else {
            setValue('bannerId', '')
            if (data.file[0] !== undefined && data.file[0].name !== null) {
                console.log(HttpHelper)
                await HttpHelper.post("Banner/UploadFileAsync", { 'Folder': 'temp', 'File': data.file[0] }, {
                    headers: {
                        'Content-Type': 'multipart/form-data; charset=utf-8',
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        data.FileId = response.data[0].fileId;
                        delete data.file;
                        BannerAdd(data)
                    } else {
                        console.log('error while uploading the image');
                    }
                }).catch((error) => {
                    console.log(error);
                })
            } else {
                props.showToast('Error', 'Please add image also Succesfully');
            }
            data.MetaData = JSON.stringify(data.MetaData);
        }
    };
    const BannerAdd = async (data) => {
        delete data.bannerId;
        data.MetaData = JSON.stringify(data.MetaData);
        await HttpHelper.post("Banner", data).then((response) => {

            props.showToast('success', 'Banner Added Succesfully');
            setValue('Heading', '');
            setValue('file', '');
            setValue('SubHeading', '');
            setValue('MetaData[0][label]', '');
            setValue('MetaData[0][url]', '');
            setValue('MetaData[1][label]', '');
            setValue('MetaData[1][url]', '');
            setBannerImage('');
            setPopupAddEdit(false);
            setLoaderApi(false);
            GetBannerList();
        }).catch((error) => {
            setLoaderApi(false);
        })

    }
    const BannerUpdate = async (data, id, fileIdBanner) => {
        if (fileIdBanner === undefined) {
            Object.assign(data,
                { rowVersion: rowVersion },
                { bannerId: bannerIdUpdate },
                { FileId: fileId }
            );
        } else {
            Object.assign(data,
                { rowVersion: rowVersion },
                { bannerId: bannerIdUpdate },
                { FileId: fileIdBanner }
            );
        }
        delete data.file;
        data.MetaData = JSON.stringify(data.MetaData);
        await HttpHelper.put("Banner", data).then((response) => {

            props.showToast('success', 'Banner Updated Succesfully');
            setValue('Heading', '');
            setValue('SubHeading', '');
            setValue('MetaData[0][label]', '');
            setValue('MetaData[0][url]', '');
            setValue('MetaData[1][label]', '');
            setValue('MetaData[1][url]', '');
            setBannerImage('');
            setBannerId('');
            setValue("bannerId", '');
            setOriginalBannerImage('');
            setShowLoader(false);
            setFileId('');
            setAccordianStatus('0');
            emptyFormDetails();
            GetBannerList();
            setBannerId('');
            setBannerIdUpdate('');
            setPopupAddEdit(false);
            setLoaderApi(false);
        }).catch((error) => {
            setLoaderApi(false);
        })

    }
    const DeleteUploadedFile = async (fileId) => {
        await HttpHelper.delete("Banner/DeleteFileAsync?fileId=" + fileId).then((res) => {
            if (res.status === 200) {
                console.log('file deleted successfully', fileId);
            } else {
                console.log(res.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }
    const GetBannerList = async () => {
        setLoaderApi(true);
        await HttpHelper.get("Banner").then((response) => {
            setBanners(response.data.data);
            getAllPermission();
            setIsEditing(true);
            setLoaderApi(false);
        }).catch((error) => {
            console.log(error);
        })
    }
    const getBannerData = async (bannerId) => {
        setPopupAddEdit(true);
        setLoaderApi(true);
        setIsEditing(true);
        setShowLoader(true);

        setValue('Heading', '');
        setValue('SubHeading', '');
        setValue('MetaData[0][label]', '');
        setValue('MetaData[0][url]', '');
        setValue('MetaData[1][label]', '');
        setValue('MetaData[1][url]', '');
        setBannerImage('');
        setBannerId('');
        setValue("bannerId", '');
        setOriginalBannerImage('');
        setShowLoader(false);
        setBannerIdUpdate('');


        await HttpHelper.get("Banner/" + bannerId).then((response) => {
            const banner = response.data;
            let buttonData = banner.metaData !== null ? JSON.parse(banner.metaData) : null
            setValue('Heading', response.data.heading);
            setValue('SubHeading', response.data.subHeading);
            setSubHeadingData(response.data.subHeading)
            setValue('MetaData[0][label]', buttonData !== null ? buttonData[0].label : '');
            setValue('MetaData[0][url]', buttonData !== null ? buttonData[0].url : '');
            setValue('MetaData[1][label]', buttonData !== null ? buttonData[1].label : '');
            setValue('MetaData[1][url]', buttonData !== null ? buttonData[1].url : '');
            if (response.data.file !== null) {
                setBannerImage(response.data.file.fileUrl);
            } else {
                setBannerImage(null);
            }
            setBannerId(response.data.bannerId);

            setValue("bannerId", response.data.bannerId);
            setOriginalBannerImage(response.data.bannerImage);
            setFileId(response.data.fileId);

            setPrimaryKeyEncrypted(response.data.primaryKeyEncrypted);

            setRowVersion(response.data.rowVersion);

            setBannerIdUpdate(response.data.bannerId);
            //accordianStatusHandle('1');
            setLoaderApi(false);
            setShowLoader(false);
        }).catch((error) => {
            setShowLoader(false);
            console.log(error);
        })
    }
    const DeleteBannerById = async (bannerId) => {

        if (bannerId == null || bannerId == undefined) {
            return false;
        }
        swal("Are you sure, you want to delete this banner?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    setIsEditing(false);
                    formRef.current.reset();
                    await HttpHelper.delete("Banner/" + bannerId).then((response) => {
                        if (response.status === 200) {
                            props.showToast('success', 'Banner Deleted successfully');
                            GetBannerList();
                        } else {
                            props.showToast('error', response.data);
                            console.log(response.data);
                        }
                        GetBannerList();
                    }).catch((error) => {
                        props.showToast('error', error.response.data);
                        console.log(error);
                    })
                }
            }
            );
    }
    const emptyFormDetails = () => {
        setIsEditing(false)

        setValue('file', '');
        setValue('Heading', '');
        setValue('SubHeading', '');
        setSubHeadingData('');
        setValue('Content', '');
        setValue('MetaData[0][label]', '');
        setValue('MetaData[0][url]', '');
        setValue('MetaData[1][label]', '');
        setValue('MetaData[1][url]', '');
    }
    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }
    useEffect(() => {
        GetBannerList();
    }, []);
    return (
        <DashboardWrapper>
            <ToastContainer />
            <div className="DashboardWrapperChild">
                <Sidebar />
                <div className="contentWrapper">
                    <HeaderDashboard title="Website Banner" />
                    <div className="container-fluid mt-80 p-0">
                        <div className="row">
                            <p><b>Note:-</b> Banner size should be Width : 1904px & Height : 906px</p>
                            {hasAddPermissionUser == true ? <div className="col-auto">
                                {isEditing === true ? <button onClick={() => {
                                    setPopupAddEdit(true);
                                    setValue('file', '');
                                    setValue('Heading', '');
                                    setValue('SubHeading', '');
                                    setValue('Content', '');
                                    accordianStatusHandle('1');
                                    setIsEditing(false);
                                }} className="btn btnSave">Add Banner</button> : ''}
                            </div> : ''}
                            <div className="col-md-12 mb-2">
                            </div>
                            {hasAddPermissionUser == true && loaderApi == false ? <div className="col-md-12 table-responsive">
                                <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                    <table className="table tableCustomized table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    #
                                                </th>
                                                <th>
                                                    Title
                                                </th>
                                                <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                    Image
                                                </th>
                                                <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                banners.length > 0 && banners.map((banner, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{banner.heading}</td>
                                                            <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                {
                                                                    banner.file && banner.file.fileUrl ? < img src={banner.file.fileUrl} width="30" height="30" /> : null
                                                                }
                                                            </td>
                                                            <td style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                                {hasEditPermissionUser == true ? <CiEdit onClick={() => { getBannerData(banner.bannerId) }} /> : ''}
                                                                &nbsp;
                                                                {hasDeletePermissionUser == true ? <AiOutlineDelete onClick={() => { DeleteBannerById(banner.bannerId) }} /> : ''}
                                                            </td>
                                                        </tr>);
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                    <g fill="none" fill-rule="evenodd">
                                        <g transform="translate(1 1)" stroke-width="2">
                                            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </div>}

                            {hasReadPermissionUser == true ? <Accordion className="d-none" defaultActiveKey="0" activeKey={accordianStatus} ref={AccordianHandle}>
                                {hasReadPermissionUser == true ? <Accordion.Item eventKey="0" onClick={(event) => {
                                    accordianStatusHandle();
                                }}>
                                    <Accordion.Header>Banner List</Accordion.Header>
                                    <Accordion.Body onClick={(e) => {
                                        e.stopPropagation();
                                    }}>
                                        <div className="col-md-12 mb-2">
                                            <div className="cardBox cardTableWrapperDashboard">
                                                <div className="row">
                                                    {
                                                        banners.length > 0 && banners.map((banner, index) => {
                                                            return (<div key={index} className="col-md-12 mb-2">
                                                                <div className="contentGrid">
                                                                    <div className="headingGrid">
                                                                        <span className="mr-3">{index + 1} : </span>
                                                                        <h2>{banner.heading}</h2>
                                                                    </div>
                                                                    <div className="imagePreviewEdit">

                                                                        {banner.file && banner.file.fileUrl !== null ?
                                                                            <>
                                                                                <b className="imageViewButton" onClick={() => {
                                                                                    setShowImgPopup(true);
                                                                                    setImageCurrentShow(banner.file.fileUrl);
                                                                                }}>View Image</b>
                                                                            </>
                                                                            : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                                                                <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                                                                <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z" />
                                                                            </svg>}

                                                                        {banner.file && banner.file.fileUrl !== null ?
                                                                            <>
                                                                                <img src={banner.file.fileUrl} alt={banner.bannerImage} className="img-fluid d-none" />
                                                                            </>
                                                                            : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="d-none bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                                                                <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                                                                <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z" />
                                                                            </svg>}
                                                                    </div>
                                                                    {hasEditPermissionUser || hasDeletePermissionUser ? <div className="editIcons">
                                                                        {hasEditPermissionUser == true ? <svg onClick={() => getBannerData(banner.bannerId)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000" className="bi bi-pen" viewBox="0 0 16 16">
                                                                            <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                                                                        </svg> : ''}
                                                                        {hasDeletePermissionUser == true ? <svg onClick={() => DeleteBannerById(banner.bannerId)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000" className="bi bi-trash" viewBox="0 0 16 16">
                                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                                                                        </svg> : ''}
                                                                    </div> : ''}
                                                                </div>
                                                            </div>);
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item> : ''}
                                {hasEditPermissionUser || hasAddPermissionUser ? <Accordion.Item eventKey="1" onClick={() => {
                                    accordianStatusHandle();
                                }}>
                                    <Accordion.Header className="d-none">{isEditing === true ? "Update" : "Add"} Banner</Accordion.Header>
                                    <Accordion.Body onClick={(e) => {
                                        e.stopPropagation();
                                    }}>
                                        <div className="col-md-12 mb-2">
                                            {showLoader === true ?
                                                <Loader show={showLoader} height="" /> :
                                                <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="cardBox cardTableWrapperDashboard">
                                                        <h4>{isEditing === true ? "Update Banner" : "Create Banner"}</h4>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label>File : {isEditing === true ? <span class="requiredAstric"> *</span> : ''}</label>
                                                                <input type="file"  {...register('file', { required: isEditing === true ? false : true })} className="border mb-2 w-100 is-invalid" />
                                                                {errors.file?.type === 'required' && <p className="text-danger" role="alert">Image is required</p>}
                                                                {isEditing === true ?
                                                                    bannerImage !== null ? <>
                                                                        <b className="imageViewButton" onClick={() => {
                                                                            setShowImgPopup(true);
                                                                            setImageCurrentShow(bannerImage);
                                                                        }}>View Image</b>
                                                                    </> : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-image-fill" viewBox="0 0 16 16">
                                                                        <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707v5.586l-2.73-2.73a1 1 0 0 0-1.52.127l-1.889 2.644-1.769-1.062a1 1 0 0 0-1.222.15L2 12.292V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zm-1.498 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                                                                        <path d="M10.564 8.27 14 11.708V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.293l3.578-3.577 2.56 1.536 2.426-3.395z" />
                                                                    </svg>
                                                                    : null}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Heading </label>
                                                                <input type="text"  {...register("Heading")} className="border mb-2" placeholder="Heading" />

                                                            </div>
                                                            <div className="col-md-12">
                                                                <label>Sub Heading </label>
                                                                <Editor className="border" {...register("SubHeading")} placeholder="Sub heading"
                                                                    tools={[
                                                                        [Bold, Italic, Underline, Strikethrough],
                                                                        [Subscript, Superscript],
                                                                        [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                                        [Indent, Outdent],
                                                                        [OrderedList, UnorderedList],
                                                                        FontSize,FontName,
                                                                        FormatBlock,
                                                                        [Undo, Redo],
                                                                        [Link, Unlink, ViewHtml],
                                                                        [InsertTable],
                                                                        [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                                                        [DeleteRow, DeleteColumn, DeleteTable],
                                                                        [MergeCells, SplitCell],
                                                                    ]}
                                                                    ref={editor}
                                                                    defaultContent={subHeadingData}
                                                                />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Button One Text : </label>
                                                                <input {...register("MetaData[0][label]")} type="text" className="border mb-2" placeholder="Button One Text" />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Button One Url : </label>
                                                                <input {...register("MetaData[0][url]")} type="text" className="border mb-2" placeholder="Button One Url" />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Button Two Text : </label>
                                                                <input {...register("MetaData[1][label]")} type="text" className="border mb-2" placeholder="Button Two Text" />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Button Two Url: </label>
                                                                <input {...register("MetaData[1][url]")} type="text" className="border mb-2" placeholder="Button Two Url" />
                                                            </div>
                                                            {
                                                                isEditing === true ?
                                                                    <input type="hidden" {...register('bannerId')} />
                                                                    : null
                                                            }
                                                            <button className="btn btnSave mt-2" onClick={getHtml}>Save</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            }
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item> : ''}
                            </Accordion> : ''}

                        </div>
                    </div>
                </div>
            </div>
            {hasReadPermissionUser == true ? <div className={`popupWrapperImage ${showImgPopup === true ? 'd-flex' : 'd-none'}`}>
                <div className="crossPopup" onClick={() => {
                    setShowImgPopup(false);
                    setImageCurrentShow('');
                }}>
                    <RxCross1 />
                </div>
                <img src={imageCurrentShow} />
            </div> : ''}

            {hasEditPermissionUser || hasAddPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                <div className="popupEditAndAddForm">
                    <div className="popupEditAndAddFormCloseButton" onClick={() => {
                        setPopupAddEdit(false);
                        setIsEditing(true);
                    }} >
                        <RxCross2 />
                    </div>

                    {loaderApi == true ? <div className="loaderApi">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                            <g fill="none" fill-rule="evenodd">
                                <g transform="translate(1 1)" stroke-width="2">
                                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                        <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                    </path>
                                </g>
                            </g>
                        </svg>
                    </div> : <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                        <div className="cardBox">
                            <h4>{isEditing === true ? "Update Banner" : "Create Banner"}</h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>File : {isEditing === false ? <span class="requiredAstric"> *</span> : ''}</label>
                                    <input type="file"  {...register('file', { required: isEditing === true ? false : true })} className="border mb-2 w-100 is-invalid" onChange={(e) => {
                                    }} />
                                    {errors.file?.type === 'required' && <p className="text-danger" role="alert">Image is required</p>}
                                </div>
                                <div className="col-md-6">
                                    <label>Heading </label>
                                    <input type="text"  {...register("Heading")} className="border mb-2" placeholder="Heading" />

                                </div>
                                <div className="col-md-12">
                                    <label>Sub Heading :</label>
                                    <Editor className="border" {...register("SubHeading")} placeholder="Sub heading"
                                        tools={[
                                            [Bold, Italic, Underline, Strikethrough],
                                            [Subscript, Superscript],
                                            [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                            [Indent, Outdent],
                                            [OrderedList, UnorderedList],
                                            FontSize,FontName,
                                            FormatBlock,
                                            [Undo, Redo],
                                            [Link, Unlink, ViewHtml],
                                            [InsertTable],
                                            [AddRowBefore, AddRowAfter, AddColumnBefore, AddColumnAfter],
                                            [DeleteRow, DeleteColumn, DeleteTable],
                                            [MergeCells, SplitCell],
                                        ]}
                                        ref={editor}
                                        defaultContent={subHeadingData}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label>Button One Text : </label>
                                    <input {...register("MetaData[0][label]")} type="text" className="border mb-2" placeholder="Button One Text" />
                                </div>
                                <div className="col-md-6">
                                    <label>Button One Url : </label>
                                    <input {...register("MetaData[0][url]")} type="text" className="border mb-2" placeholder="Button One Url" />
                                </div>
                                <div className="col-md-6">
                                    <label>Button Two Text : </label>
                                    <input {...register("MetaData[1][label]")} type="text" className="border mb-2" placeholder="Button Two Text" />
                                </div>
                                <div className="col-md-6">
                                    <label>Button Two Url: </label>
                                    <input {...register("MetaData[1][url]")} type="text" className="border mb-2" placeholder="Button Two Url" />
                                </div>
                                {
                                    isEditing === true ?
                                        <input type="hidden" {...register('bannerId')} />
                                        : null
                                    }
                                    <div className="col-md-12 d-flex justify-content-end mt-6">
                                    <div>
                                        <button className="btn btnSave mt-2" onClick={getHtml}>Save</button>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </form>}

                </div>
            </div> : ''}
        </DashboardWrapper>
    )
}

export default DashboardBanner;